import React, { useEffect, useState } from 'react';
import { Settings, Check, Lock } from 'lucide-react';
import { Button } from './ui/Button';
import { Card } from './ui/Card';
interface Column {
  key: string;
  label: string;
}
interface ColumnCustomizerProps {
  columns: Column[];
  visibleColumns: string[];
  onColumnChange: (columns: string[]) => void;
  pageKey: string;
  lockedColumns?: string[];
}
export function ColumnCustomizer({
  columns,
  visibleColumns,
  onColumnChange,
  pageKey,
  lockedColumns = []
}: ColumnCustomizerProps) {
  const [isOpen, setIsOpen] = useState(false);
  // Load saved preferences on mount
  useEffect(() => {
    const saved = localStorage.getItem(`columns_${pageKey}`);
    if (saved) {
      try {
        const parsed = JSON.parse(saved);
        if (Array.isArray(parsed) && parsed.length > 0) {
          // Ensure locked columns are always included
          const merged = Array.from(new Set([...parsed, ...lockedColumns]));
          onColumnChange(merged);
        }
      } catch (e) {
        console.error('Failed to parse saved columns', e);
      }
    } else if (lockedColumns.length > 0) {
      // If no saved preference, ensure locked columns are visible
      const merged = Array.from(new Set([...visibleColumns, ...lockedColumns]));
      onColumnChange(merged);
    }
  }, [pageKey]); // Only run when pageKey changes
  const toggleColumn = (key: string) => {
    // Prevent toggling locked columns
    if (lockedColumns.includes(key)) return;
    const newColumns = visibleColumns.includes(key) ? visibleColumns.filter(c => c !== key) : [...visibleColumns, key];
    // Don't allow hiding all columns
    if (newColumns.length === 0) return;
    onColumnChange(newColumns);
    localStorage.setItem(`columns_${pageKey}`, JSON.stringify(newColumns));
  };
  return <div className="relative z-20" data-id="element-108" data-mp="16vkoics4xst4">
      <Button variant="flat" color="secondary" size="md" onClick={() => setIsOpen(!isOpen)} startContent={<Settings className="h-4 w-4" data-id="element-110" data-mp="14amwdfc976wb" />} data-id="element-109" data-mp="16wm8x7v1jrni">
        Colonne
      </Button>

      {isOpen && <>
          <div className="fixed inset-0 z-10" onClick={() => setIsOpen(false)} data-id="element-111" data-mp="19a9cbwjgv18t"></div>
          <div className="absolute right-0 mt-2 w-56 bg-white rounded-xl shadow-xl border border-slate-100 z-20 p-2 animate-in fade-in zoom-in-95 duration-200" data-id="element-112" data-mp="ubfag3rge3xl">
            <div className="px-2 py-2 border-b border-slate-50 mb-1" data-id="element-113" data-mp="lk593qa6x3ic">
              <h4 className="text-xs font-bold text-slate-500 uppercase tracking-wider" data-id="element-114" data-mp="liu1tghjddmh">
                Personalizza Vista
              </h4>
            </div>
            <div className="max-h-60 overflow-y-auto custom-scrollbar space-y-0.5" data-id="element-115" data-mp="bmqulw7tuoso">
              {columns.map(col => {
            const isLocked = lockedColumns.includes(col.key);
            const isVisible = visibleColumns.includes(col.key);
            return <button key={col.key} onClick={() => toggleColumn(col.key)} disabled={isLocked} className={`
                      w-full flex items-center justify-between px-3 py-2 rounded-lg text-sm transition-colors
                      ${isLocked ? 'text-slate-400 cursor-not-allowed bg-slate-50' : isVisible ? 'bg-seform-orange/10 text-seform-orange font-medium' : 'text-slate-600 hover:bg-slate-50'}
                    `} data-id="element-116" data-mp="6ne4n2lnt1lv">
                    <span className="flex items-center gap-2" data-id="element-117" data-mp="6w549k6uhaiq">
                      {col.label}
                      {isLocked && <Lock className="h-3 w-3 opacity-50" data-id="element-118" data-mp="1y3cmavcs2vn" />}
                    </span>
                    {isVisible && <Check className="h-3.5 w-3.5" data-id="element-119" data-mp="foyozx52923z" />}
                  </button>;
          })}
            </div>
          </div>
        </>}
    </div>;
}